import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const CREATE_OPP_TOKEN = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createOppToken',
    operationName: 'createOppToken',
    args: [
      { name: 'primary_customer_id', type: 'String', required: true },
      { name: 'project_id', type: 'String', required: true },
      { name: 'customer_ids', type: '[String]' },
      { name: 'project_name', type: 'String' },
      { name: 'company_branch_id', type: 'String' },
      { name: 'assigned_to', type: 'String' },
      { name: 'opportunity_id', type: 'String' },
      { name: 'buyer_aws_id', type: 'String' },
      { name: 'currency_code', type: 'String' },
      { name: 'amount_minor', type: 'Int' },
      { name: 'sr_source_of_finance', type: 'String' },
    ],
    argsMap: [
      { name: 'primary_customer_id', value: 'primary_customer_id' },
      { name: 'project_id', value: 'project_id' },
      { name: 'customer_ids', value: 'customer_ids' },
      { name: 'project_name', value: 'project_name' },
      { name: 'company_branch_id', value: 'company_branch_id' },
      { name: 'assigned_to', value: 'assigned_to' },
      { name: 'opportunity_id', value: 'opportunity_id' },
      { name: 'buyer_aws_id', value: 'buyer_aws_id' },
      { name: 'currency_code', value: 'currency_code' },
      { name: 'amount_minor', value: 'amount_minor' },
      { name: 'sr_source_of_finance', value: 'sr_source_of_finance' },
    ],
    fields: '{...CreateOppTokenResponseFields}',
    fragments: [Fragments.createOppTokenResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const CREATE_TOKEN_PAYMENT = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createTokenPayment',
    operationName: 'createTokenPayment',
    args: [
      { name: 'token_id', type: 'String', required: true },
      { name: 'amount_minor', type: 'String', required: true },
      { name: 'currency_code', type: 'String', required: true },
      { name: 'method', type: 'String', required: true },
      { name: 'paid_by_buyer_name', type: 'String', required: true },
      { name: 'customer_id', type: 'String' },
      { name: 'reference_number', type: 'String' },
      { name: 'status', type: 'String' },
      { name: 'notes', type: 'String' },
      { name: 'receipt_media_id', type: 'String' },
    ],
    argsMap: [
      { name: 'token_id', value: 'token_id' },
      { name: 'amount_minor', value: 'amount_minor' },
      { name: 'currency_code', value: 'currency_code' },
      { name: 'method', value: 'method' },
      { name: 'customer_id', value: 'customer_id' },
      { name: 'reference_number', value: 'reference_number' },
      { name: 'status', value: 'status' },
      { name: 'notes', value: 'notes' },
      { name: 'receipt_media_id', value: 'receipt_media_id' },
      { name: 'paid_by_buyer_name', value: 'paid_by_buyer_name' },
    ],
    fields: '{...CreateTokenPaymentResponseFields}',
    fragments: [Fragments.createTokenPaymentResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

// CPI-979 — Create an ONLINE-gateway (MHub Pay) token payment.
// method must be 'online'. Returns checkout_url for the MPW redirect and
// forwards return_url so book-api can set MPA's client_return_url. Separate from
// CREATE_TOKEN_PAYMENT so manual (cash/bank_transfer) payments never request the
// gateway-only checkout_url field.
export const CREATE_TOKEN_PAYMENT_ONLINE = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createTokenPayment',
    operationName: 'createTokenPayment',
    args: [
      { name: 'token_id', type: 'String', required: true },
      { name: 'amount_minor', type: 'String', required: true },
      { name: 'currency_code', type: 'String', required: true },
      { name: 'method', type: 'String', required: true },
      { name: 'paid_by_buyer_name', type: 'String', required: true },
      { name: 'reference_number', type: 'String' },
      { name: 'return_url', type: 'String' },
    ],
    argsMap: [
      { name: 'token_id', value: 'token_id' },
      { name: 'amount_minor', value: 'amount_minor' },
      { name: 'currency_code', value: 'currency_code' },
      { name: 'method', value: 'method' },
      { name: 'paid_by_buyer_name', value: 'paid_by_buyer_name' },
      { name: 'reference_number', value: 'reference_number' },
      { name: 'return_url', value: 'return_url' },
    ],
    fields: `{
      id
      token_id
      amount_minor
      currency_code
      method
      online_pay_id
      checkout_url
      status
      paid_at
      created_at
      updated_at
    }`,
    fragments: [],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
